module.exports = __webpack_public_path__ + "img/lange_crub_4.5b7b7904.jpg";